import dayjs from 'dayjs';
import 'dayjs/locale/es';

/** Last day of the current month, the deadline to generate an invoice, as "31 de marzo". */
export const getInvoicingDeadlineLabel = (): string => dayjs().endOf('month').locale('es').format('D [de] MMMM');
